import React from "react";
import { useNavigate } from "react-router-dom";
import { formatRevenuePeriod } from "./formatRevenuePeriod";
import { slugify } from "../AssetDashboard/slugify";

interface Props {
  assetData: any[];
}

const PortfolioRevenueWidget: React.FC<Props> = ({
  assetData,
}) => {
// const PortfolioRevenueWidget = () => {
//   const { assetData } = useDataContext();
  const navigate = useNavigate();

  const revenues = [...assetData]
    .map((asset: any) => ({
      ...asset,
      revenue: Number(asset.yesterdayRevenue ?? 0),
    }))
    .sort((a, b) => b.revenue - a.revenue);
  const revenuePeriod = revenues.find((asset) => asset.revenuePeriod)?.revenuePeriod;
  const formattedRevenuePeriod = formatRevenuePeriod(revenuePeriod);

  const maxRevenue = Math.max(
    ...revenues.map((a) => Math.abs(a.revenue)),
    1
  );

  const handleClick = (asset: any) => {
    navigate(
      `/asset-dashboard/estimated-settlements/${slugify(
        asset.asset_name
      )}`,
      {
        state: {
          ASSET_ID: asset.asset_id,
          ASSET_NAME: asset.asset_name,
          ASSET_TYPE: asset.asset_type,
          ISO_CODE: asset.ISO,
        },
      }
    );
  };

  return (
    <div className="h-full min-h-0 overflow-hidden rounded-xl border border-gray-300 bg-white p-5 shadow-md">
      <div className="flex h-full min-h-0 flex-col">
      <h2 className="mb-4 flex-shrink-0 text-2xl font-semibold">
        Estimated Revenue By Asset{formattedRevenuePeriod ? ` - As of ${formattedRevenuePeriod}` : ""}
      </h2>

      <div className="min-h-0 flex-1 space-y-3 overflow-y-auto pr-2">
        {revenues.map((asset) => (
          <div
            key={asset.asset_id}
            onClick={() => handleClick(asset)}
            className="flex items-center gap-4 cursor-pointer hover:bg-gray-50 p-2 rounded"
          >
            <div className="w-48 truncate text-sm font-medium">
              {asset.asset_name}
            </div>

            <div className="flex-1 bg-gray-200 h-6 rounded">
              <div
                className="bg-blue-500 h-6 rounded"
                style={{
                  width: `${
                    (Math.abs(asset.revenue) / maxRevenue) * 100
                  }%`,
                }}
              />
            </div>

            <div className="w-32 text-right font-semibold">
              $
              {asset.revenue.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>
          </div>
        ))}
      </div>
      </div>
    </div>
  );
};

export default PortfolioRevenueWidget;